import { render, staticRenderFns } from "./COD-Branch-Total.vue?vue&type=template&id=a392b8c2&scoped=true"
import script from "./COD-Branch-Total.vue?vue&type=script&lang=js"
export * from "./COD-Branch-Total.vue?vue&type=script&lang=js"
import style0 from "./COD-Branch-Total.vue?vue&type=style&index=0&id=a392b8c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a392b8c2",
  null
  
)

export default component.exports